import * as TimeLimitUtils from '../../../utils/TimeLimitUtils';
import * as Constants from '../../../data/Constants';

/**
 * Assumes time limits exist when editing a category
 * @param {*} state
 * @returns object used to initialize state
 */
export const initializeTimeLimits = (state) => {
  state = setTimeLimitSwitchOn(state);
  state = initializeDaysOfWeekUI(state);
  state = setIsValidStateForTimeLimitSubfields(state);

  return state;
};

const setTimeLimitSwitchOn = (state) => {
  state.timeLimitSwitch = true;
  return state;
};

const initializeDaysOfWeekUI = (state) => {
  state.timeLimits.map((timeLimitItem, timeLimitIndex) => {
    state.daysOfWeekButtons.push(new Array(7));
    Constants.days.map((element, index) => {
      if (timeLimitItem.daysOfWeek.includes(element.key)) {
        state.daysOfWeekButtons[timeLimitIndex][index] = true;
      }
    });
  });
  return state;
};

const setIsValidStateForTimeLimitSubfields = (state) => {
  const { timeLimits } = state;
  const timeLimitIsValid = TimeLimitUtils.areAllTimeLimitsValid(timeLimits);
  state.areTimeLimitSubfieldsValid = [];
  timeLimits.forEach((timeLimit) => {
    state.areTimeLimitSubfieldsValid.push(TimeLimitUtils.whatInDayTimeLimitIsValid(timeLimit));
  });

  if (!timeLimitIsValid) {
    state.isFieldInvalid[Constants.timeLimitsIndex] = true;
    state.disableSaveButton = true;
  }
  return state;
};
